export default "__VITE_ASSET__CtcI2ZMY__"